import {Box, Typography} from "@mui/material";
import {useRouteError} from "react-router-dom"; // Убедись, что хук импортирован правильно
import LoginPage from '../routes/login'; // Импорт формы логина
import PageTitle from "./PageTitle";

export default function BookingNotFoundError() {
    const error = useRouteError(); // Получаем информацию об ошибке

    // Проверяем, если ошибка 401 (Unauthorized)
    if (error?.response?.status === 401) {
        return <LoginPage/>; // Рендерим страницу логина
    }

    if (error?.response?.status === 403) {
        return (
        <Box className='flex abs-center center-text fullwh' sx={{height: '100vh'}}>
            <PageTitle title="Доступ заборонено" />
            <Box>
                <h1>У вас немає прав на перегляд даного бронювання</h1>
                <h2>Якщо ви впевнені, що це помилка:</h2>
                <h3>Повідомте нам за телефоном</h3>
                <a href='tel:+380000000000'>
                    <Typography sx={{my: 2}}>
                        +380 00 000 00 00
                    </Typography>
                </a>
                <a href='/'>
                    <Typography variant='h4' sx={{fontWeight: 'bold'}}>
                        на головну
                    </Typography>
                </a>
            </Box>
        </Box>
    );
    }

    // В остальных случаях показываем сообщение об ошибке бронирования
    return (
        <Box className='flex abs-center center-text fullwh' sx={{height: '100vh'}}>
            <PageTitle title="Бронювання не знайдено" />
            <Box>
                <h1>Бронювання не знайдено!</h1>
                <h2>Якщо ви впевнені, що це помилка:</h2>
                <h3>Повідомте нам за телефоном</h3>
                <a href='tel:+380000000000'>
                    <Typography sx={{my: 2}}>
                        +380 00 000 00 00
                    </Typography>
                </a>
                <a href='/'>
                    <Typography variant='h4' sx={{fontWeight: 'bold'}}>
                        на головну
                    </Typography>
                </a>
            </Box>
        </Box>
    );
}
